import { z } from "zod";
// What a ClickHouse read did not cover (PR B readers). ClickHouse is the only
// source of the analytics reads; a range the copier and the live producers
// have not covered is reported here instead of being returned as zeros.
// `provider` null = no provider has any coverage for the table at all.
export const CoverageGapSchema = z.object({
    provider: z.string().nullable(),
    table: z.string(),
    from: z.string(),
    to: z.string(),
});
export const CoverageSchema = z.object({
    from: z.string(),
    to: z.string(),
    uncovered: z.array(CoverageGapSchema),
});
//# sourceMappingURL=coverage.js.map